export const CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST = "CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST";
export const CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS = "CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS";
export const CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE = "CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE";

export const FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST = 'FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST';
export const FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS = 'FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS';
export const FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE = 'FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE';


export const UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST = 'UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST';
export const UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS = 'UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS';
export const UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE = 'UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE';
export const UPDATE_BOOTCAMP_SUBSCRIPTION_RESET = 'UPDATE_BOOTCAMP_SUBSCRIPTION_RESET';